var map = {
	"./icon1.png": "2gnB",
	"./icon2.png": "hRqn",
	"./icon3.png": "YbqD",
	"./icon4.png": "lg+e"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jwS0";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/dataCenter ^\.\/icon.*\.png$
// module id = jwS0
// module chunks = 1